export enum OfferingPassEligibility {
  ANYONE = 'ANYONE',
  ONLY_MEN = 'ONLY_MEN',
  ONLY_WOMEN = 'ONLY_WOMEN',
  ONLY_LEADERS = 'ONLY_LEADERS',
  ONLY_FOLLOWERS = 'ONLY_FOLLOWERS',
  ONLY_COUPLES_MAN_WOMAN = 'ONLY_COUPLES_MAN_WOMAN',
  ONLY_COUPLES_LEADER_FOLLOWER = 'ONLY_COUPLES_LEADER_FOLLOWER',
  FIXED_GROUP_SIZE = 'FIXED_GROUP_SIZE',
}

/**
 * @deprecated Use AdditionalPassHolder for secondary attendees with full data.
 * Kept for backwards compatibility during DOD-497 transition.
 */
export interface GroupAttendee {
  name: string;
  isPrimary: boolean;
}

/**
 * DOD-497 — secondary attendee on a couple/group order.
 * Matches the BE `additionalPassHolders[]` field on `POST /api/customers/self/orders`.
 *
 * The buyer (primary) is sent separately via `passHolderName`/`passHolderEmail`/
 * `passHolderGender` and is NOT included here.
 */
export interface AdditionalPassHolder {
  name: string;
  /** 'MALE' | 'FEMALE' | 'DIVERSE' (matches GenderType from authentication-portal). */
  gender: string;
  /** Multi-select dance roles (e.g. ['LEADER'], ['LEADER', 'FOLLOWER'], ['SOLO']). */
  danceRoles: string[];
}
